import { render, staticRenderFns } from "./AdvisorCoreNav.vue?vue&type=template&id=1dca94ac&scoped=true&"
import script from "./AdvisorCoreNav.vue?vue&type=script&lang=js&"
export * from "./AdvisorCoreNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dca94ac",
  null
  
)

export default component.exports